import React, { useState, useEffect } from 'react';

import { useGetWeight } from 'api/services';
import ChartModal from 'components/ChartModal/ChartModal';
import { chartsKey } from 'utils/constants';

import { getGradientBackground } from './utils/chartColorizing';
import {
	defaultChartAxisValues,
	handleChartData,
	getChartMaxValue,
	increaseOrDecreaseMaxYThreshold,
} from './utils/chartHelpers';
import { defaultConfig, styledChartElements } from './utils/customViewChart';

const Weight = ({ closeChart, isOpen }) => {
	const [data, setData] = useState({});
	const [chartConfig, setChartConfig] = useState(null);
	const [labelsData, setLabelsData] = useState(undefined);

	const { data: weightData, loading } = useGetWeight();
	const isDataAvailable = weightData?.data && weightData.data.length > 0;

	useEffect(() => {
		if (isDataAvailable) {
			const dataAdapted = handleChartData(weightData.data);

			setData(dataAdapted);
			setLabelsData(dataAdapted?.labels);
			handleChartConfig();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [weightData]);

	const handleChartConfig = () => {
		const minY = defaultChartAxisValues[chartsKey.weight].minY;
		let maxY = defaultChartAxisValues[chartsKey.weight].maxY;

		const maxValueOfY = getChartMaxValue(weightData.data, 'value');

		if (maxValueOfY && maxValueOfY >= maxY) {
			maxY = maxValueOfY + increaseOrDecreaseMaxYThreshold.xxl;
		}

		const config = {
			...defaultConfig,
			elements: styledChartElements(weightData.data.length - 1),
			scales: {
				...defaultConfig.scales,
				y: {
					...defaultConfig.scales.y,
					min: minY,
					max: maxY,
				},
			},
		};

		setChartConfig(config);
	};

	const getChartData = (canvas) => {
		const gradient = getGradientBackground(canvas);

		return {
			...data,
			datasets: [
				{
					data: data?.datasets[0]?.data,
					fill: true,
					backgroundColor: gradient,
				},
			],
		};
	};

	return (
		<ChartModal
			loading={loading}
			labelsData={labelsData}
			data={getChartData}
			closeChart={closeChart}
			chartConfig={chartConfig}
			isOpen={isOpen}
		/>
	);
};

export default Weight;
